import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";

const FormSelectSearchAsyncField = ({
  label,
  name,
  control,
  options,
  setSearchTerm,
  placeholder,
  isLoading,
  validationError,
}) => {
  return (
    <Form.Group controlId={label} className="mb-2">
      <Form.Label>{label}</Form.Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            options={options}
            isLoading={isLoading}
            loadingMessage={() => "Nalaganje..."}
            value={field.value}
            onChange={(selectedOption) => field.onChange(selectedOption)}
            onInputChange={(inputValue) => setSearchTerm(inputValue)}
            placeholder={placeholder || "Izberi..."}
            noOptionsMessage={() => "Ni rezultatov"}
          />
        )}
      />
      {validationError && <p className="text-danger">{validationError}</p>}
    </Form.Group>
  );
};

export default FormSelectSearchAsyncField;
